import { render, staticRenderFns } from "./VerkaCaptcha.vue?vue&type=template&id=2b3bc90d&scoped=true&"
import script from "./VerkaCaptcha.vue?vue&type=script&lang=ts&"
export * from "./VerkaCaptcha.vue?vue&type=script&lang=ts&"
import style0 from "./VerkaCaptcha.vue?vue&type=style&index=0&id=2b3bc90d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3bc90d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
